const LOCATIONS_TO_SPACES = {
  // 'wellpact.menschchef.co.uk': '08209ebc-5b8d-428e-86a4-559454f781b3',
  // localhost: 'ae5a029f-d08e-447e-a818-cb342b97afb7',
  'demo-staging.smorg.io': 'ae5a029f-d08e-447e-a818-cb342b97afb7',
  // 'app.veganrunnereats.com': '08d92a03-3dad-4e55-91f1-eb2332ef91ef',
  // 'app.theglowspace.co.uk': '74de44c6-f816-44f9-a8be-aad76ee95406',
  'app.fitnessmadepractical.com': '90ff19f3-f93d-4871-a47a-b5acc1a5a147',
  // 'app.lifestylemedicalcenters.com': '7fd555a7-ba05-40dd-9582-2bf09376182b',
};

export const getCurrentLocation = () => {
  return window.location.hostname;
};

export const getDomainSpaceID = () => {
  const currentLocation = getCurrentLocation();
  if (!currentLocation) {
    return null;
  }
  return LOCATIONS_TO_SPACES[currentLocation];
};
